<template>
  <div>    
    <div class="valign-wrapper section">
      <span style="padding: 0px 5px 0px 0px">
        <a v-on:click.prevent="toModeVue()">
          <a class="waves-effect waves-light btn-flat btn-small indigo lighten-5">Вернуться к упражнению</a>
        </a>
      </span>      
    </div>
    
    <br />
    <a class="indigo-text text-lighten-1">Курс {{course.name}}</a>
    <br />
    <a class="black-text">Упражнение: {{mode.name}} {{regimeName}}</a>
    
    <br />
    <span>
      <a class="indigo-text text-lighten-1">ПРОГРЕСС ПО УПРАЖНЕНИЮ</a>
    </span>

    <div class="progress grey lighten-3">
      <div
        class="determinate indigo lighten-1"
        v-bind:style="{width: progressMode_erSatz_percent + '%'}"
      ></div>
    </div>
    

    <div
      v-if="!(parseInt(progressMode[18])>0)"
    >Начните упражение, чтобы увидеть показатели прогресса</div>

    <div v-else>

      <h6>Прогресс по упражнению: {{progressMode_erSatz_percent}} %</h6>      
        <div v-if="progressMode_erSatz_percent >= this.erSatzLevel*100"> 
          <br />
          Можете переходить к 
              <a
                v-on:click.prevent="toCourseVue"
                class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
              >следующему занятию              
              </a>
        </div>      
        <div v-else>
        Упражнение автоматически отметится 'Пройдено', когда прогресс будет более 80%. 
        </div>

      <br />

      <h6>Проработанность, %</h6>
      <BarChart v-bind:data="dataBarChart" v-bind:styles="stylesBarChart" />
      <br />
      <br />

      <h6>Предложения</h6>
      Всего: {{progressMode[18]}}
      <PieChart v-bind:data="dataPieChart.kolSatz" v-bind:styles="stylesPieChart" />
      <br />
      <br />

      <h6>Слова</h6>
      Всего: {{parseInt(progressMode[3])+parseInt(progressMode[4])
      +parseInt(progressMode[5])+parseInt(progressMode[6])+parseInt(progressMode[7])}}
      <PieChart v-bind:data="dataPieChart.kolWort" v-bind:styles="stylesPieChart" />
      <br />
      <br />

      <h6>Глагольные формы</h6>
      Всего: {{parseInt(progressMode[8])+parseInt(progressMode[9])
      +parseInt(progressMode[10])+parseInt(progressMode[11])+parseInt(progressMode[12])}}
      <PieChart v-bind:data="dataPieChart.kolVerb" v-bind:styles="stylesPieChart" />
    </div>
    
  </div>
</template>

<style scoped>
.section {
  padding-top: 0;
  padding-bottom: 0;
}
</style>

<script>
import BarChart from "@/components/BarChart";
import PieChart from "@/components/PieChart";

export default {
  name: "course",
  components: { BarChart, PieChart},
  data: () => ({
    stylesBarChart: {
      width: "300px",
      height: "180px",
      position: "relative"
    },
    stylesPieChart: {
      width: "350px",
      height: "180px",
      position: "relative"
    }
  }),
  computed: {
    course() {
      return this.$store.getters.course;
    },
    mode() {
      return this.$store.getters.mode;
    },
    regimeName() {
      switch (this.$store.getters.idMode0) {
        case "Hor-0":
          return "Hören";
        case "Sp-0":
          return "Sprechen";
        case "Sch-0":
          return "Schreiben";
      }
      return null;
    },
    progressMode() {
      return this.$store.getters.progressMode;
    },
    progressMode_erSatz_percent() {
      let p = Number(this.progressMode[2]);
      return (p * 100).toFixed(2);
    },
    erSatzLevel() {
      return this.$store.getters.erSatzLevel;
    },

    dataBarChart() {
      let data = [
        {
          name: "Предложения",
          ready: (Number(this.progressMode[2]) * 100).toFixed(1)
        },
        {
          name: "Слова",
          ready: (Number(this.progressMode[0]) * 100).toFixed(1)
        },
        {
          name: "Глагольн. формы",
          ready: (Number(this.progressMode[1]) * 100).toFixed(1)
        }
      ];
      return data;
    },

    dataPieChart() {
      let data = {
        kolWort: {
          "Ещё не начато": this.progressMode[3],
          "Давно или очень много ошибок": this.progressMode[4],
          "0%-30% мало проработано": this.progressMode[5],
          "30%-80% средне проработано": this.progressMode[6],
          "80%-100% хорошо проработано": this.progressMode[7]
        },
        kolVerb: {
          "Ещё не начато": this.progressMode[8],
          "Давно или очень много ошибок": this.progressMode[9],
          "0%-30% мало проработано": this.progressMode[10],
          "30%-80% средне проработано": this.progressMode[11],
          "80%-100% хорошо проработано": this.progressMode[12]
        },
        kolSatz: {
          "Ещё не начато": this.progressMode[13],
          "Давно или очень много ошибок": this.progressMode[14],
          "0%-30% мало проработано": this.progressMode[15],
          "30%-80% средне проработано": this.progressMode[16],
          "80%-100% хорошо проработано": this.progressMode[17]
        }
      };
      return data;
    }
  },
  mounted() {},
  methods: {
    toModeVue() {            
      this.$router.push("/course/mode")
    },
    toCourseVue() {            
      this.$router.push("/course/course")
    }
  }
};
</script>
